function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_408",
  "data-name": "Path 408",
  d: "M37.814,4H7.757A3.74,3.74,0,0,0,4.019,7.757L4,41.571l7.514-7.514h26.3A3.756,3.756,0,0,0,41.571,30.3V7.757A3.756,3.756,0,0,0,37.814,4ZM34.057,26.543H11.514V22.786H34.057Zm0-5.636H11.514V17.15H34.057Zm0-5.636H11.514V11.514H34.057Z",
  transform: "translate(-0.243 -0.243)",
  fill: "#f03f1d"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_409",
  "data-name": "Path 409",
  d: "M0,0H45.086V45.086H0Z",
  fill: "none"
});

var SvgSmsPay = function SvgSmsPay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_210",
    "data-name": "Group 210",
    width: 45.086,
    height: 45.086,
    viewBox: "0 0 45.086 45.086",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmsPay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/SMSPay.17d53358.svg";
export { ForwardRef as ReactComponent };